import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { getMitchellProxy, testMitchellProxy, saveMitchellProxy } from "../../../helpers/api";

const AZUL = "#3790ed";
const MUTED = "#6b7a90";

const vacio = { host: "", port: "", user: "", pass: "", protocol: "http" };

export default function MitchellProxyPage() {
  const [form, setForm] = useState(vacio);
  const [hasPass, setHasPass] = useState(false);
  const [info, setInfo] = useState({ por: null, cuando: null });
  const [loading, setLoading] = useState(true);
  const [probando, setProbando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const cargar = () => {
    setLoading(true);
    getMitchellProxy()
      .then((d) => {
        setForm({ host: d.host || "", port: d.port || "", user: d.user || "", pass: "", protocol: d.protocol || "http" });
        setHasPass(!!d.hasPass);
        setInfo({ por: d.actualizadoPor || null, cuando: d.actualizado || null });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(cargar, []);

  const cambiar = (campo) => (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));

  const faltan = () => !form.host.trim() || !String(form.port).trim() || !form.user.trim() || !form.pass;

  const probar = () => {
    if (faltan() || probando || guardando) return;
    setMsg({ type: "", text: "" });
    setProbando(true);
    testMitchellProxy(form)
      .then((r) => setMsg({ type: r.ok ? "success" : "warning", text: r.message || (r.ok ? "Works" : "Did not work") }))
      .catch((r) => setMsg({ type: "warning", text: (r && r.message) || "Could not test." }))
      .finally(() => setProbando(false));
  };

  const guardar = () => {
    if (faltan() || probando || guardando) return;
    setMsg({ type: "", text: "" });
    setGuardando(true);
    saveMitchellProxy(form)
      .then((r) => {
        setMsg({ type: r.ok ? "success" : "warning", text: r.message || "Done" });
        if (r.ok) cargar();
      })
      .catch((r) => setMsg({ type: "warning", text: (r && r.message) || "Could not save." }))
      .finally(() => setGuardando(false));
  };

  const campo = (etiqueta, campoNombre, tipo, placeholder) => (
    <div style={{ marginBottom: "12px" }}>
      <label style={{ display: "block", fontWeight: 700, color: "#1d2735", marginBottom: "4px", fontSize: "0.9rem" }}>
        {etiqueta}
      </label>
      <input
        type={tipo}
        value={form[campoNombre]}
        onChange={cambiar(campoNombre)}
        placeholder={placeholder}
        autoComplete="off"
        disabled={probando || guardando}
        style={{
          width: "100%", padding: "10px 12px", borderRadius: "10px",
          border: "2px solid #e6ebf2", fontSize: "0.95rem", boxSizing: "border-box",
        }}
      />
    </div>
  );

  const boton = (texto, onClick, principal, cargando) => (
    <button
      onClick={onClick}
      disabled={probando || guardando || faltan()}
      style={{
        flex: 1, padding: "12px 16px", borderRadius: "12px", border: "none",
        fontWeight: 800, cursor: probando || guardando || faltan() ? "not-allowed" : "pointer",
        color: principal ? "#fff" : AZUL,
        background: principal ? AZUL : "#eef4fd",
        opacity: probando || guardando || faltan() ? 0.6 : 1,
      }}
    >
      {cargando ? <Spinner animation="border" size="sm" /> : texto}
    </button>
  );

  return (
    <PrettyContainer tittle="MITCHELL PROXY">
      <div style={{ paddingTop: "0.6em", maxWidth: "520px" }}>
        <p style={{ color: MUTED }}>
          The residential proxy (US IP) that ProDemand and TruckSeries use to reach Mitchell.
          If Mitchell blocks the IP, buy a new <b>static residential</b> proxy and enter it here:
          press <b>Test</b> and, if it works, <b>Save &amp; restart</b>. Both services switch to the
          new proxy automatically.
        </p>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px", color: MUTED }}>
            <Spinner animation="border" size="sm" /> Loading…
          </div>
        ) : (
          <>
            {info.por && (
              <div style={{ color: MUTED, fontSize: "0.82rem", marginBottom: "10px" }}>
                Last change by <b>{info.por}</b>
                {info.cuando ? " · " + new Date(info.cuando).toLocaleString() : ""}
                {hasPass ? " · a password is saved (type it again to change it)" : ""}
              </div>
            )}

            {msg.text && <Alert variant={msg.type}>{msg.text}</Alert>}

            {campo("IP / Host", "host", "text", "e.g. 48.45.163.44")}
            {campo("Port", "port", "text", "e.g. 46168")}
            {campo("User", "user", "text", "proxy username")}
            {campo("Password", "pass", "password", hasPass ? "•••••• (type to change)" : "proxy password")}

            <div style={{ display: "flex", gap: "12px", marginTop: "6px" }}>
              {boton("Test", probar, false, probando)}
              {boton("Save & restart", guardar, true, guardando)}
            </div>

            {(probando || guardando) && (
              <div style={{ color: MUTED, fontSize: "0.85rem", marginTop: "10px" }}>
                <Spinner animation="border" size="sm" />{" "}
                {guardando ? "Testing and applying… (gateways restart, ~15s)" : "Testing the proxy… (~15s)"}
              </div>
            )}
          </>
        )}
      </div>
    </PrettyContainer>
  );
}
